$(document).ready(function () {
  $("span.toolbar-icon.icon-mode").click(function () {
    var productItems = $("li div.product-item");
    productItems.removeClass(
      "active-product-item1 active-product-item2 active-product-item3 active-product-item4 active-product-item5 active-product-item-list"
    );
    var gridClass = null;
    for (var grid = 1; grid <= 5; grid++) {
      var activeSpan = $(
        "span.toolbar-icon.icon-mode.icon-mode-grid.grid-" + grid + ".active"
      );
      if (activeSpan.length) {
        gridClass = "active-product-item" + grid;
        break;
      }
    }
    if (gridClass === null) {
      var activeSpan = $("span.toolbar-icon.icon-mode.icon-mode-list.active");
      if (activeSpan.length) {
        gridClass = "active-product-item-list";
      }
    }
    if (gridClass !== null) {
      productItems.addClass(gridClass);
    }
  });

  $("span.toolbar-icon.icon-mode").click();
});


